module.exports = __webpack_public_path__ + "img/FDCA-Logo-Lockup.svg";